<template>
	<div class="i-xlsx">
		
	</div>
</template>

<script>
//import XLSX from 'xlsx';
export default {

  name: 'i-xlsx',

  mounted(){
	var worksheet = XLSX.utils.aoa_to_sheet(data);
	var new_workbook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(new_workbook, worksheet, "SheetJS");
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>